<template>
  <v-layout row justify-center>
    <v-dialog v-model="localShow" persistent :max-width="width">
      <v-card class="v-card d-flex text-center align-center flex-column">
        <div class="v-card-h1" :class="headerColor">{{ title }}</div>

        <div class="v-card-h3 mt-2">
          <v-layout v-if="!hasSlotData">
            <v-flex>{{ text }}</v-flex>
          </v-layout>

          <slot name="body" />
        </div>

        <v-card-actions class="d-flex justify-center px-0 flex-row mt-8">
          <v-btn v-if="showCancel" large outlined min-width="100" elevation="0" color="primary" @click="close">
            {{ cancelText }}
          </v-btn>

          <v-btn large min-width="100" elevation="0" color="primary" @click="confirm">{{ confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// @vuese
// Okno z potwierdzeniem
export default {
  props: {
    // Czy wyświetlać
    show: {
      type: Boolean,
      default: false
    },
    // id
    id: {
      type: Number,
      required: false,
      default: undefined
    },
    // Tytuł dialogu
    title: {
      type: String,
      required: true,
      default: undefined
    },
    // Text do wyświetlenia w dialogu
    text: {
      type: String
    },
    // Czy pokazać przycisk anulowania
    showCancel: {
      type: Boolean,
      required: false,
      default: true
    },
    // Text do anulowania
    cancelText: {
      type: String,
      required: false,
      default: 'Nie'
    },
    // Text do potwierdzenia
    confirmText: {
      type: String,
      required: false,
      default: 'Tak'
    },
    // Szerokość dialogu
    width: {
      type: Number,
      required: false,
      default: 400
    },
    // klasa header
    headerColor: {
      type: String
    },
    // Czy zamykać modal po potwierdzeniu
    closeOnConfirm: { type: Boolean, default: true }
  },
  computed: {
    localShow() {
      return this.show;
    },
    hasSlotData() {
      return this.$slots.body;
    }
  },
  methods: {
    // @vuese
    // Funkcja zamykająca okno
    close() {
      this.$emit('close');
    },
    // @vuese
    // Funkcja potwierdzająca okno o danym ID
    confirm() {
      this.$emit('confirm', this.id);
      if (this.closeOnConfirm) {
        this.close();
      }
    }
  }
};
</script>

<style>
.materialDialogActions {
  display: -webkit-box !important;
}
</style>
